var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "54", height: "54", viewBox: "0 0 54 54", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { fillRule: "nonzero", fill: "none" },
      React.createElement("path", { d: "M27 0c14.912 0 27 12.088 27 27S41.912 54 27 54 0 41.912 0 27 12.088 0 27 0z", fill: "#E1E1E1" }),
      React.createElement("path", { d: "M39.494 34.674l-2.882-1.922-2.562-1.707a1.135 1.135 0 0 0-1.524.247L30.94 33.33a1.13 1.13 0 0 1-1.442.3c-1.075-.6-2.348-1.163-5.155-3.973-2.807-2.811-3.374-4.08-3.972-5.155a1.13 1.13 0 0 1 .299-1.442l2.038-1.586c.469-.365.576-1.03.247-1.524L21.3 17.467l-1.974-2.961a1.135 1.135 0 0 0-1.528-.344l-2.277 1.366a2.782 2.782 0 0 0-1.263 1.634c-.623 2.27-.749 7.278 7.277 15.304 8.025 8.025 13.032 7.899 15.302 7.276a2.781 2.781 0 0 0 1.635-1.263l1.366-2.277c.312-.52.16-1.192-.344-1.528z", fill: "#FFF" })
    )
  );
});